import { useContext } from 'react';

import {
  Button,
  Header,
  Icon,
  Loader,
  ModalContainer,
  ModalLayoutCenter,
  ModalLayoutFullScreen,
  SkeletonLoader,
  Text,
  useIsDesktop,
} from '@kanda-libs/ks-design-library';

import Context from './Context';
import { CLASS_NAMES, COPY, MODAL_ID } from './constants';
import useEmailResend from './useEmailResend';

const JobLockedModal = ({}) => {
  const isDesktop = useIsDesktop();
  const { locked } = useContext(Context);
  const { sent, onResendJob, isSubmitting } = useEmailResend();

  const copyKey = locked ? 'locked' : 'unlocked';

  const ModalLayout = isDesktop ? ModalLayoutCenter : ModalLayoutFullScreen;

  const modalProps = (id: string, handleClose: () => void) => ({
    id,
    onClose: handleClose,
    ...(!isDesktop && {
      header: (
        <Header.Base
          className="text-style-f-em text-neutral-700"
          hideNumber
          options={[
            <Button.Icon
              id="create-job-close-modal-close"
              key="close"
              onClick={handleClose}
              icon="close"
            />,
          ]}
        />
      ),
      noBorder: true,
    }),
  });

  return (
    <ModalContainer id={MODAL_ID} overlay opacity={40}>
      {({ id, handleClose }) => (
        <ModalLayout {...modalProps(id, handleClose)}>
          <div className={CLASS_NAMES.contentWrapper}>
            <Icon
              icon="shield-check"
              className="text-purple-300 w-12 h-12 mx-auto mb-4"
            />
            <Text text={COPY[copyKey].title} className={CLASS_NAMES.title} />
            <Text
              text={COPY[copyKey].description}
              className={CLASS_NAMES.description}
            />
            <div className={CLASS_NAMES.sendWrapper}>
              {!sent && !isSubmitting && (
                <Button.InlineLink
                  id="job-locked-modal-resend-email"
                  variant="turquoise"
                  disabled={isSubmitting}
                  onClick={onResendJob}
                  label="No email? Click to resend"
                  className={CLASS_NAMES.icon}
                />
              )}
              {isSubmitting && (
                <SkeletonLoader isLoading width={150} height={18} />
              )}
              {sent && !isSubmitting && (
                <div className={CLASS_NAMES.sentWrapper}>
                  <Icon icon="check" className={CLASS_NAMES.sentIcon} />
                  <Text text="Email sent" className={CLASS_NAMES.sentText} />
                </div>
              )}
            </div>
            <Loader isLoading={isSubmitting} />
          </div>
        </ModalLayout>
      )}
    </ModalContainer>
  );
};

export default JobLockedModal;
